/**
 *
 * @file 个人中心/数据看板
 *
 **/

import AXIOS from '@/utils/$axios';

// 所有数据
export const getAllData = data =>
    AXIOS.post('/space/enterprise/data-board/get-all', data);

// 单项数据
export const getItemData = data =>
    AXIOS.post('/space/enterprise/data-board/get-alone', data);
// 单项数据
export const getManegers = data =>
    AXIOS.post('/space/enterprise/common/get-ent-project-roles', data);

// 项目状态列表
export const getProjects = data => {
    return AXIOS.post(
        '/space/enterprise/data-board/get-project-status-list',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );
};

// 项目满意度列表
export const getSatisfactionList = data =>
    AXIOS.post('/space/enterprise/data-board/get-project-opinion-list', data, {
        responseType: data.export === 1 ? 'blob' : 'json',
    });

// 项目满意度列表
export const getSatisfactionDetail = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-project-opinion-detail',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 巡检质量列表
export const getQualityList = data =>
    AXIOS.post('/space/enterprise/data-board/get-examine-quality-list', data, {
        responseType: data.export === 1 ? 'blob' : 'json',
    });

// 巡检质量详情
export const getQualityDetail = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-examine-quality-detail',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 巡检异常统计列表
export const getAbnormalList = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-examine-exception-list',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 巡检质量详情
export const getAbnormalDetail = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-examine-exception-detail',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 装修待办异常统计列表
export const getBacklogList = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-notepad-exception-list',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 装修待办异常统计详情
export const getBacklogDetail = data =>
    AXIOS.post(
        '/space/enterprise/data-board/get-notepad-exception-detail',
        data,
        {
            responseType: data.export === 1 ? 'blob' : 'json',
        }
    );

// 装修待办异常统计列表
export const getStageSatisfactionList = data =>
    AXIOS.post('/space/enterprise/data-board/get-stage-opinion-list', data, {
        responseType: data.export === 1 ? 'blob' : 'json',
    });

// 施工阶段满意度详情
export const getStageSatisfactionDetail = data =>
    AXIOS.post('/space/enterprise/data-board/get-stage-opinion-detail', data, {
        responseType: data.export === 1 ? 'blob' : 'json',
    });
